<div
  class="gd-form-toggle-checkbox-v2">

  <!-- Input data -->
  <mat-button-toggle
    *ngIf="!viewOnly; else viewOnlyTemplate"
    [checked]="value"
    [disabled]="disabled"
    (change)="value = !value">

    <!-- Left - Icon buttons -->
    <ng-container
      *ngIf="tooltipButton?.tooltip"
      matPrefix>
      <popper-content
        #popperContent>
        <div
          [innerHtml]="tooltipButton.tooltip | safeHtml">
        </div>
      </popper-content>
      <mat-icon
        tabindex="-1"
        [popper]="popperContent"
        popperTrigger="hover"
        popperApplyClass="gd-form-input-v2-tooltip"
        popperPreventOverflow="true"
        popperPositionFixed="true"
        popperAppendTo="body"
        (click)="$event.stopPropagation()">{{tooltipButton.icon}}</mat-icon>
    </ng-container>

    <!-- Icon -->
    <mat-icon
      class="gd-form-toggle-checkbox-v2-toggle-icon">{{value ? 'toggle_on' : 'toggle_off'}}</mat-icon>

    <!-- Label -->
    <span>
      {{placeholder | translate}}
    </span>

    <!-- Right - Icon buttons -->
    <ng-container
      *ngFor="let iconB of suffixIconButtons"
      matSuffix>
      <span
        *ngIf="!iconB.visible || iconB.visible(this)"
        (click)="$event.stopPropagation()">
        <button
          tabindex="-1"
          type="button"
          mat-icon-button
          [matTooltip]="iconB.tooltip | translate"
          [disabled]="iconB.disabled && iconB.disabled(this)"
          (click)="iconB.clickAction ? iconB.clickAction(this) : undefined"><mat-icon>{{iconB.icon}}</mat-icon></button>
      </span>
    </ng-container>

  </mat-button-toggle>

  <!-- View only -->
  <ng-template
    #viewOnlyTemplate>
    <div
      fxLayout="row" fxLayoutGap="1.6rem"
      class="gd-form-toggle-checkbox-v2-viewonly">
      <!-- Label -->
      <div
        class="gd-form-toggle-checkbox-v2-viewonly-label">
        {{ placeholder | translate }}:
      </div>

      <!-- Value -->
      <div
        class="gd-form-toggle-checkbox-v2-viewonly-value">
        {{(value ? 'LNG_COMMON_LABEL_YES' : 'LNG_COMMON_LABEL_NO') | translate}}
      </div>
    </div>
  </ng-template>
</div>
